var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"todo-main"},[_c('transition-group',{attrs:{"name":"todo","appear":""}},_vm._l((_vm.todos),function(todo){return _c('TodoItem',{key:todo.id,attrs:{"todo":todo}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }